import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const codonUsageTool: Tool = {
  id: "codon-usage",
  name: () => m.codon_tool_name(),
  description: () => m.codon_tool_description(),
  icon: "🧬",
  basePath: "/codon-usage",
  status: "stable",
  tags: ["bioinformatics", "dna", "rna", "codon", "science", "gene-expression"],
};
